export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-move@2x-28df81ddddde808770ad4965abea7731.webp";